import React, { FC } from "react";
import { InputSelectProperties, } from "src/framework/components/forms";
import { Checkbox, Chip, createStyles, FormControl, InputLabel, ListItemText, makeStyles, MenuItem, Select, Theme, } from "@material-ui/core";

import "./style.css";

export interface FormasPagamentos {
  id: number;
  nome: string;
}

export interface InputSelectFormasPagamentosProperties extends InputSelectProperties {
  list: FormasPagamentos[];
  value: number[];
  onChange(value: any): void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    menuHeader: {
      backgroundColor: theme.palette.background.default,
    },
    chip: {
      margin: 2,
    },
  })
);

const InputSelectFormasPagamentos: FC<InputSelectFormasPagamentosProperties> = (props: InputSelectFormasPagamentosProperties) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selecteds: number[] = event.target.value as number[];
    if (props.onChange) {
      props.onChange(
        props.list.filter((reg: FormasPagamentos) => selecteds.indexOf(reg.id) > -1)
      );
    }
  };

  return (
    <FormControl
      fullWidth={true}
      variant="outlined"
      size={"small"}
      className={classes.formControl}
    >
      <InputLabel id="select-forma_pagto-label" style={{ backgroundColor: "#fff", padding: "0px 1px" }}>
        {props.label}
      </InputLabel>
      <Select
        style={{ textAlign: "left" }}
        labelId="select-forma_pagto-label"
        id="forma_pagto-mutiple-checkbox"
        multiple
        value={props.value}
        onChange={handleChange}
        renderValue={(selected) => {
          const selectedFormasPagamentos: FormasPagamentos[] =
            props.list.filter(
              (reg: FormasPagamentos) => (selected as number[]).indexOf(reg.id) > -1
            ) || [];
          return (
            <div className={classes.chip}>
              {selectedFormasPagamentos.map((tipoContas) => (
                <Chip
                  key={tipoContas.id}
                  label={tipoContas.nome}
                  className={classes.chip}
                  size={"small"}
                />
              ))}
            </div>
          );
        }}
        MenuProps={MenuProps}>
        {props.list.map((_perfil: FormasPagamentos) => (
          <MenuItem key={_perfil.nome} value={_perfil.id}>
            <Checkbox checked={props.value.indexOf(_perfil.id) > -1} />
            <ListItemText primary={_perfil.nome} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { InputSelectFormasPagamentos };
